export interface GoogleCalendarRef {
  id: string;
  summary?: string;
}

export interface GoogleCalendarConfiguration {
  /** Empty means the primary calendar only. */
  calendars?: GoogleCalendarRef[];
  /** Google's event colour id ("1"–"11") that marks an event as a task. */
  taskColorId?: string;
}

/**
 * Google Calendar's fixed event colour palette, in the order Google's own picker
 * shows them. The ids are what the API stores in an event's `colorId`; names are
 * translated in the i18n layer.
 */
export const GoogleCalendarEventColourIds = [
  "11",
  "4",
  "6",
  "5",
  "2",
  "10",
  "7",
  "9",
  "1",
  "3",
  "8",
] as const;

export type GoogleCalendarEventColourId = (typeof GoogleCalendarEventColourIds)[number];
